/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest,
  PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationResponse,
  PostApiV1CourseregistrationEnrollmentBatchStatusChange400,
  PostApiV1CourseregistrationEnrollmentBatchStatusChange401,
  PostApiV1CourseregistrationEnrollmentBatchStatusChange500,
} from "../../types/courseRegistrationEnrollmentController/PostApiV1CourseregistrationEnrollmentBatchStatusChange.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1CourseregistrationEnrollmentBatchStatusChange } from "../../clients/courseRegistrationEnrollmentController/postApiV1CourseregistrationEnrollmentBatchStatusChange.ts";

export const postApiV1CourseregistrationEnrollmentBatchStatusChangeMutationKey =
  () =>
    [
      { url: "/api/v1/courseregistration/enrollment/batch-status-change" },
    ] as const;

export type PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationKey =
  ReturnType<
    typeof postApiV1CourseregistrationEnrollmentBatchStatusChangeMutationKey
  >;

export function postApiV1CourseregistrationEnrollmentBatchStatusChangeMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey =
    postApiV1CourseregistrationEnrollmentBatchStatusChangeMutationKey();
  return mutationOptions<
    PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationEnrollmentBatchStatusChange400
      | PostApiV1CourseregistrationEnrollmentBatchStatusChange401
      | PostApiV1CourseregistrationEnrollmentBatchStatusChange500
    >,
    {
      data?: PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1CourseregistrationEnrollmentBatchStatusChange(
        data,
        config,
      );
    },
  });
}

/**
 * @description Altera o status de matrícula de todos os alunos selecionados da turma para o status destino informado. Para status de cancelamento (Cancelado, Cancelado em Inscrição, Rejeitado), os campos StatusReasonId, SubStatusReasonId e Observation são obrigatórios. Cancela parcelas em aberto e recusa vínculo de bolsa quando aplicável. **(Requer Authorization para autenticação)**
 * @summary Altera o status de matrícula de vários alunos em lote (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/batch-status-change}
 */
export function usePostApiV1CourseregistrationEnrollmentBatchStatusChange<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationResponse,
      ResponseErrorConfig<
        | PostApiV1CourseregistrationEnrollmentBatchStatusChange400
        | PostApiV1CourseregistrationEnrollmentBatchStatusChange401
        | PostApiV1CourseregistrationEnrollmentBatchStatusChange500
      >,
      {
        data?: PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1CourseregistrationEnrollmentBatchStatusChangeMutationKey();

  const baseOptions =
    postApiV1CourseregistrationEnrollmentBatchStatusChangeMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationResponse,
      ResponseErrorConfig<
        | PostApiV1CourseregistrationEnrollmentBatchStatusChange400
        | PostApiV1CourseregistrationEnrollmentBatchStatusChange401
        | PostApiV1CourseregistrationEnrollmentBatchStatusChange500
      >,
      {
        data?: PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest;
      },
      TContext
    >;

  return useMutation<
    PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationEnrollmentBatchStatusChange400
      | PostApiV1CourseregistrationEnrollmentBatchStatusChange401
      | PostApiV1CourseregistrationEnrollmentBatchStatusChange500
    >,
    {
      data?: PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationEnrollmentBatchStatusChange400
      | PostApiV1CourseregistrationEnrollmentBatchStatusChange401
      | PostApiV1CourseregistrationEnrollmentBatchStatusChange500
    >,
    {
      data?: PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest;
    },
    TContext
  >;
}
